const overlayBase = "absolute inset-0 flex items-center justify-center bg-slate-950/75 px-6 transition-all duration-500 ease-out";
const overlayVisible = "pointer-events-auto opacity-100 backdrop-blur-md";
const overlayHidden = "pointer-events-none opacity-0 backdrop-blur-0";

const panelBase = "relative w-full max-w-xl transition-all duration-500";
const panelVisible = "translate-y-0 scale-100 opacity-100";
const panelHidden = "translate-y-4 scale-95 opacity-0";

const buttonBaseClasses =
  "inline-flex w-full items-center justify-center gap-2 rounded-2xl px-14 text-sm font-semibold text-white shadow-lg shadow-slate-900/25 transition-colors duration-200 transition-transform hover:-translate-y-1 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-offset-2 focus:ring-offset-white disabled:cursor-not-allowed disabled:opacity-60";
const gradientButtonClasses = "bg-gradient-to-r from-slate-900 to-slate-950 hover:from-slate-800 hover:to-slate-800";

export const getOverlayClasses = (isOpen) =>
  `${overlayBase} ${isOpen ? overlayVisible : overlayHidden}`;

export const getModalPanelClasses = (isOpen) =>
  `${panelBase} ${isOpen ? panelVisible : panelHidden}`;

export const modalButtonClasses = {
  base: buttonBaseClasses,
  gradient: gradientButtonClasses,
  primary: `${buttonBaseClasses} ${gradientButtonClasses} py-[14px]`,
  google: `${buttonBaseClasses} ${gradientButtonClasses} py-[8px]`,
  googleIconWrapper: "flex h-8 w-8 items-center justify-center rounded-full bg-white text-slate-900 shadow",
};
